import { Table } from "antd";
import React from "react";

export const SummaryTable = ({ data }) => {
  const columns = [
    {
      title: "File Name",
      dataIndex: "fileName",
      key: "fileName",
      width: 200,
      ellipsis: true,
    },
    {
      title: "Times",
      dataIndex: "times",
      key: "times",
      width: 80,
    },
    {
      title: "Total Duration",
      dataIndex: "totalDuration",
      key: "totalDuration",
      width: 120,
    },
  ];

  return (
    <div style={{ overflowX: "auto" }}>
      <Table
        columns={columns}
        dataSource={data}
        rowKey="fileName"
        pagination={false}
        bordered
        scroll={{ x: 400 }}
        size="middle"
      />
    </div>
  );
};
